export default __webpack_public_path__ + "static/media/icons8-python.3d8526f0.svg";